var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113 155",
    style: {
      enableBackground: "new 0 0 113 155"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB2F06;}\r\n\t.st1{fill:#0C2461;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.59,149.53c-12.56-14.61-24.08-29.98-33.7-46.7C12.31,93.11,7.41,83.06,4.38,72.19 c-4.55-16.3-2.44-31.69,7-45.72C20.34,13.14,33,5.14,49,2.91c15.64-2.18,29.75,1.81,41.96,11.76c10.77,8.78,17.18,20.2,19.37,34 c1.7,10.73-0.35,20.93-4.05,30.91c-4.97,13.37-12.07,25.62-19.95,37.45c-7.58,11.37-15.93,22.17-24.87,32.5 C58,153,55,153,51.59,149.53z M56.35,84.17C71.19,84.42,83.6,72.22,83.88,57.1C84.15,42.04,72,29.6,56.76,29.34 c-14.94-0.26-27.37,11.97-27.6,27.13C28.94,71.55,41.07,83.9,56.35,84.17z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 56.64,
    cy: 56.84,
    r: 20.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationPin);
export default __webpack_public_path__ + "static/media/icon_location-pin.40c3921100c89315d80fef407c7eae36.svg";
export { ForwardRef as ReactComponent };